const SALE_UNIT_PLURALS: Record<string, string> = {
  pc: "pcs", piece: "pieces", set: "sets", unit: "units", lot: "lots", pair: "pairs", dozen: "dozen", pack: "packs", bundle: "bundles",
  bag: "bags", sack: "sacks", box: "boxes", carton: "cartons", roll: "rolls", sheet: "sheets", ream: "reams", drum: "drums", can: "cans", tube: "tubes",
  truckload: "truckloads", trip: "trips", hour: "hours", day: "days", week: "weeks", month: "months",
};

export const canonicalSaleUnit = (unit: string) => Object.keys(SALE_UNIT_PLURALS).find((singular) => singular === unit || SALE_UNIT_PLURALS[singular] === unit) || unit;

// Sale posting and marketplace cards share quantity wording; measurements and custom units stay as entered.
export const saleUnitLabel = (unit: string, quantity: string) => {
  const singular = canonicalSaleUnit(unit);
  return !quantity.trim() || Number(quantity) === 1 ? singular : SALE_UNIT_PLURALS[singular] || unit;
};
